var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-divider",style:(_vm.color ? 'color:' + _vm.color : '')},[(_vm.content !== '')?_c('div',{staticClass:"m-divider__content"},[_vm._v(" "+_vm._s(_vm.content)+" ")]):_c('div',{staticClass:"m-divider__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }